import {
  FulfillmentTypeListResponseType,
  OrderGetResponseType,
  StockListResponseType,
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";
import { SpinnerLegacy } from "../../../../../components";
import { ContextOrderBasketType } from "../../../../../hooks";
import Item from "../../Item";
import { PoweredBySellar } from "../PoweredBySellar";
import { CheckoutSelectedFulfillmentType } from "../../..";

export const StorefrontChildProductListContent = ({
  productsListQuery,
  supplier,
  submittedOrder,
  supplierStorefront,
  basketOrder,
  basketTotal,
  selectedFulfillmentType,
  courierFulfillmentType,
}: {
  productsListQuery: UseInfiniteQueryResult<
    InfiniteData<StockListResponseType>
  >;
  basketOrder?: ContextOrderBasketType | null | undefined;
  basketTotal?: number;
  submittedOrder?: OrderGetResponseType;
  courierFulfillmentType: FulfillmentTypeListResponseType[number] | undefined;
  supplier: SupplierGetResponseType | undefined;
  supplierStorefront: SupplierStorefrontV2GetResponseType | undefined;
  selectedFulfillmentType: CheckoutSelectedFulfillmentType;
}) => {
  return (
    <div className={"flex flex-col gap-2"}>
      {productsListQuery.isLoading ? (
        <SpinnerLegacy />
      ) : productsListQuery.data?.pages[0]?.length ? (
        productsListQuery.data.pages[0].map((product, i) => (
          <Item
            item={product}
            key={i}
            supplier={supplier}
            supplierStorefront={supplierStorefront}
            basketOrder={basketOrder}
            submittedOrder={submittedOrder}
            basketTotal={basketTotal}
            selectedFulfillmentType={selectedFulfillmentType}
            courierFulfillmentType={courierFulfillmentType}
          />
        ))
      ) : (
        <div className={"text-center"}>
          <span>No Results Found</span>
        </div>
      )}
      <div className={"flex"}>
        <PoweredBySellar />
      </div>
    </div>
  );
};
